var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecoricon03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 75,
    viewBox: "0 0 109 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99666 37.2303C13.1744 10.4426 40.7089 -5.45426 67.4967 1.7235C94.1348 8.8613 110.003 36.1285 103.121 62.7743C96.6742 50.2302 85.3078 40.0077 70.5289 36.0477C44.4712 29.0656 17.6986 43.6302 7.9615 69.0887C3.99043 59.3121 3.055 48.2089 5.99666 37.2303Z",
    fill: "#18466F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2581 53.2258C11.5187 51.3363 11.7793 49.4469 12.3045 47.8871C12.8297 46.3274 13.6115 45.1546 14.4171 43.9463",
    stroke: "#FFF4E2",
    strokeWidth: 3.99938,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6581 44.4757C99.0027 42.6845 98.3474 40.8932 97.5034 39.4803C96.6595 38.0674 95.6467 37.0871 94.6033 36.0771",
    stroke: "#FFF4E2",
    strokeWidth: 3.99938,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9062 33.0868C23.6229 30.8715 24.3396 28.6563 25.7513 26.5052C27.163 24.3542 29.2479 22.3344 31.396 20.2534",
    stroke: "#FFF4E2",
    strokeWidth: 3.99938,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0037 27.2642C82.8336 25.2513 81.6635 23.2384 79.8278 21.4356C77.9921 19.6328 75.5263 18.101 72.9858 16.5229",
    stroke: "#FFF4E2",
    strokeWidth: 3.99938,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9902 16.4268C45.2068 15.2938 47.4234 14.1609 50.1168 13.6019C52.8103 13.0429 55.9135 13.0922 59.1107 13.1429",
    stroke: "#FFF4E2",
    strokeWidth: 3.99938,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecoricon03);
export default __webpack_public_path__ + "static/media/decoricon03.ddc22b4eb7a7361aee44828c55517f65.svg";
export { ForwardRef as ReactComponent };